import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import SmallSpinner from "../../components/shared/spinners/SmallSpinner"
import Button from "../../components/shared/Button"
import PageTopTitle from "../../components/shared/PageTopTitle"
import Btn from "../../components/shared/button/Btn"
import { clearSendCashNotificationFromExcel, sendCashNotificationFromExcel } from "../../features/admin3/admin3Slice"
import { useSelector } from "react-redux"
import { validateExcelFile } from "../../helper/docs/validateExcelFile"

const Container = styled.div`

width: 100%;

    .wrapper{
        display: flex;
        flex-direction: column;
        width: 100%;

        .content{
            margin: 40px 30px;
            display: flex;
            width: auto;
            flex-direction: column;
            align-items: center;
            gap: 50px;
            color: ${({theme}) => theme.mainTextColor};
            margin-bottom: 100px;

            .toplu-excel-container {
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: 30px 40px;
                border-radius: 10px;
                margin: 0 auto;
                margin-top: 40px;
                background-color: rebeccapurple;
                width: auto;
                background-color: ${({ theme }) => theme.secondaryBgColor};

                h3 {
                    font-size: var(--font-size-lg);
                    font-weight: var(--font-weight-xl);
                    margin-bottom: 45px;
                    color: ${({ theme }) => theme.mainTextColor};
                    text-align: center;
                }

                .res-text{
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-lg);
                }

                .reset{
                    color: var(--color-main);
                    font-weight: var(--font-weight-xl);
                    text-decoration: underline;
                    cursor: pointer;
                }

                .input-grp {
                display: flex;
                align-items: center;

                .file-input-label {
                    width: 160px;
                    padding: 0 10px;
                    line-height: 40px;
                    text-align: center;
                    height: 40px;
                    background-color: ${({ theme }) => theme.utilityBtnBg};
                    color: #fff;
                    border-radius: 10px;
                    border: 1px solid;
                    cursor: pointer;
                    border-color: ${({ theme }) => theme.mainBorderColor};
                }

                .file-name {
                    font-size: 16px;
                    font-weight: var(--font-weight-lg);
                    color: ${({ theme }) => theme.mainTextColor};
                    padding: 0 20px;
                }

                .file-input {
                    display: none;
                }
                }
            }

            .excel-response-container{
                display: flex;
                gap: 40px;

                .excel-response-column{
                    display: flex;
                    flex-direction: column;
                    padding: 20px 40px;
                    border-radius: 10px;

                    h3{
                        font-size: var(--font-size-md);
                        font-weight: var(--font-weight-lg);
                        margin-bottom: 10px;
                        text-decoration: underline;
                    }

                    .list{
                        display: flex;
                        flex-direction: column;
                        gap: 10px;

                        .list-item{
                            font-size: var(--font-size-sm);
                            font-weight: var(--font-weight-md);
                        }
                    }

                    &:first-child{
                        background-color: #ff000016;
                    }
                    
                    &:last-child{
                        background-color: #00800016;
                    }
                }
            }
        }
    }
`


const TahsilatBildirimi = () => {

    const dispatch = useDispatch()
    const [file, setFile] = useState(null)
    const {sendCashNotificationFromExcelResponseList, isLoadingSendCashNotificationFromExcel, sendCashNotificationFromExcelResponseStatus} = useSelector(state => state.admin3)

    useEffect(() => {

        return () => {
            dispatch(clearSendCashNotificationFromExcel())
        }
    },[])

    const handleFileChange = async(e) => {

        const file = await validateExcelFile({file: e.target.files[0], maxSize: 5 * 1024 * 1024, allowedTypes: ["text/csv", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel.sheet.macroEnabled.12"]})
        
        if(file){
            setFile(e.target.files[0])
        }
    }

  return (
    <Container>
        <div className="wrapper">
            <PageTopTitle title={"Tahsilat Bildirimi"} position="sticky" />
            <div className="content">
                <div className="toplu-excel-container">
                    <h3>Excel İle Tahsilat Toplu Bildirim Gönderme</h3>
                    {
                        sendCashNotificationFromExcelResponseStatus ?
                        <div className="res-text"> <span style={{fontWeight: 600}}>{file?.name}</span> dosyası başarılı bir şekilde gönderildi. <span onClick={() => {dispatch(clearSendCashNotificationFromExcel()); setFile(null)}} className="reset">Sıfırla</span></div>
                        :
                        <>
                    <div className="input-grp">
                    <label className="file-input-label" htmlFor="detayFile">
                        Dosya Seç
                    </label>


                    <div className="file-name">{file?.name || "Dosya Seçin"}</div>
                    <input
                        type="file"
                        id="detayFile"
                        className="file-input"
                        onChange={handleFileChange}
                    />
                    {
                        file &&
                        <Btn
                            color={"#E85446"}
                            bgColor={"#fff"}
                            width="auto"
                            radius={"10px"}
                            padding="0 20px"
                            handleClick={() => dispatch(sendCashNotificationFromExcel(file))}
                        >{
                            isLoadingSendCashNotificationFromExcel ? (
                            <SmallSpinner
                            size={"20px"}
                            color={"#fff"}
                            bgColor={"#E85446"}
                            />
                        ) : (
                            "Bildirim Gönder"
                        )
                        }</Btn>
                    }
                    </div>
                    </>
                    }
                </div>

                <div className="excel-response-container">
                    {
                       (!isLoadingSendCashNotificationFromExcel && sendCashNotificationFromExcelResponseList.filter(item => item.sentSuccess).length > 0) &&
                        <div className="excel-response-column">
                            <h3>Bildirim Gönderilen Üyeler</h3>
                            <div className="list">
                                {sendCashNotificationFromExcelResponseList.filter(item => item.sentSuccess).map(item => (
                                    <div className="list-item">
                                        {item.name}
                                    </div>
                                ))}
                            </div>
                        </div>
                    }      
                    {
                        (!isLoadingSendCashNotificationFromExcel && sendCashNotificationFromExcelResponseList.filter(item => !item.sentSuccess).length > 0) &&
                    <div className="excel-response-column">
                        <h3>Bildirim Gönderilemeyen Üyeler</h3>
                        <div className="list">
                            {sendCashNotificationFromExcelResponseList.filter(item => !item.sentSuccess).map(item => (
                                <div className="list-item">
                                    {item.name}
                                </div>
                            ))}
                        </div>
                    </div>
                    }
                </div>
            </div>
        </div>
    </Container>
  )
}

export default TahsilatBildirimi